// Shared asset origin for application code and Node build scripts.
const ASSETS_BASE_URL = 'https://clients.vilvabusiness.com/';
const ASSETS_ORIGIN = new URL(ASSETS_BASE_URL).origin;

const LOGO_URL = `${ASSETS_BASE_URL}cleanflowsystem/cleanlogo.eaa0434c.png`;

module.exports = { ASSETS_BASE_URL, ASSETS_ORIGIN, LOGO_URL };
